export default __webpack_public_path__ + "link.b48ab0a3be0986c7.svg";